// Offer Fulfillment Priority (OCST-28864) — Yup counterpart of OfferFulfillmentPrioritySchema,
// for the campaign components still validated with Yup (Sweepstakes, Punchcard, Challenge, Game).
// Optional positive whole number bounded to 1000.
//
// TODO: Remove this Yup shape once all consumers have migrated to Zod and use
// OfferFulfillmentPrioritySchema directly.
import * as yup from 'yup';

import { FULFILLMENT_PRIORITY_RANGE_ERROR_MESSAGE_TEXT } from '@occc-app/lib/constants/validationMessages';

import { FULFILLMENT_PRIORITY_MAX } from './offer-fulfillment-priority.validation';

export const offerFulfillmentPrioritySchemaShape = {
  fulfillmentPriorityLevel: yup
    .number()
    .integer()
    .positive(FULFILLMENT_PRIORITY_RANGE_ERROR_MESSAGE_TEXT)
    .max(FULFILLMENT_PRIORITY_MAX, FULFILLMENT_PRIORITY_RANGE_ERROR_MESSAGE_TEXT)
    .optional(),
};
